import { useEffect, useState } from "react"

const DESKTOP_BREAKPOINT = 1024

function getIsDesktop() {
  return typeof window !== "undefined" && window.innerWidth >= DESKTOP_BREAKPOINT
}

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(getIsDesktop)

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`)
    const update = (event?: MediaQueryListEvent) => {
      setIsDesktop(event ? event.matches : mediaQuery.matches)
    }

    update()

    mediaQuery.addEventListener("change", update)
    return () => mediaQuery.removeEventListener("change", update)
  }, [])

  return isDesktop
}
